import { find } from 'lodash-es';
import { put, select } from 'redux-saga/effects';
import { fetchChannelsApi } from 'common/api/index';
import { navigationSetInStoreAction } from 'common/actions/navigation';
import { navigationItemModel } from 'common/api/models/index';
import { activateNavItemInTree } from 'utils/navigation-utils';
import { errorHandleAction } from 'components/error-handle/actions';
import { channelsSelector } from 'common/selectors/channels';
import { channelsSuccessAction } from 'common/actions/channels';
import { navBarRootChannelsSelector } from 'common/selectors/settings';

/**
 * @param {navigationBuildAction} action
 */
export function* navigationBuildEffect({ payload: { currentChannelId } }) {
  try {
    /**
     * if not provided, from navigation perspective it is homepage
     * @example currentChannelId === null|undefined
     */
    let channels = yield select(channelsSelector);
    if (!channels.length) {
      channels = yield fetchChannelsApi();
      yield put(channelsSuccessAction(channels));
    }
    let rootChannels = yield select(navBarRootChannelsSelector);
    const navigation = yield channels.map(navigationItemModel).filter((navItem) => {
      if (navItem.parentId === null) {
        return true;
      }
      const isRoot = navItem.parentId === -1;
      const isInRootList = !!find(rootChannels, ['id', navItem.id]);
      return !isRoot || (isRoot && isInRootList);
    });
    yield activateNavItemInTree(navigation, currentChannelId);
    yield put(navigationSetInStoreAction(navigation));
  } catch (error) {
    yield put(errorHandleAction(error, error.status));
  }
}
